module.exports = __webpack_public_path__ + "static/media/bonobology.3d769dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/bonobology.jpg
// module id = 28
// module chunks = 0